import AbstractController from '../../../Controller/AbstractController';
import Controller from '../../../Controller/Controller';
import Timetable from '../Elements/Timetable';
import NextCourses from '../Elements/NextCourses';

/**
 * Timetable Controller
 *
 * @class
 */
class TimetableController extends AbstractController {
  /**
   * @constructor
   */
  constructor() {
    super();

    Controller.registerController(this);
    this._registerElements(
      ...Timetable,
      ...NextCourses
    );
  }
}

export default new TimetableController();
